import React from 'react';
import PropTypes from 'prop-types';
import { FormSection } from 'AppSrc/core/components/forms/form-section';
import { prefixStringWithIndexPlusOne } from 'AppSrc/core/utility-functions/string-fun';
import { navigationPropsShape } from 'AppSrc/core/components/forms/section-nav';
import { userRolesPropShape } from 'AppSrc/core/auth/auth-proptypes';
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
import {
  formDataShape,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import {
  APPROVERS_SECTION,
  SECTION_TITLES,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import { sstApproverGroupNames } from './sst-approver-group-names';
import { mandatoryApproverGroupNames } from './mandatory-approver-group-names';
import { approverGroupNames } from './approver-group-names';
import { isCrqEmergency } from '../common-logic';

// Section ID (for the data layer)
const sectionId = APPROVERS_SECTION;
// Title for the main form
const sectionTitle = SECTION_TITLES[APPROVERS_SECTION];


// callback for the form section to figure out what fields to render with conditional logic
const getCurrentFields = (params) => {

  // const {
  //   // values = {},
  //   // formData = {},
  //   // touched = {},
  //   // userRoles,
  // } = params;

  // taking impact level in impactlevelCheck from params for simplification.
  const impactLevelCheck = params.formData.dataByFormSectionId.CHANGE_QUESTIONS.dataByFieldId.impact.value;
  const currentFields = [];
  const isEmergency = isCrqEmergency(params.formData);
  currentFields.push({
    ...defaultFieldLogic,
    componentData: (impactLevelCheck === '1000' || impactLevelCheck === '2000') ? sstApproverGroupNames : mandatoryApproverGroupNames,
  });
  currentFields.push({
    ...defaultFieldLogic,
    componentData: approverGroupNames,
    optional: (impactLevelCheck === '3000' || impactLevelCheck === '4000') && !isEmergency ? false : true, // as we want approver section to be mandatory for impact level 3 and 4.
  });

  return currentFields;
};

// generates the formSection!
const ApproversSection = React.memo(({
  // saves locally and goes to the next page
  handleSuccessfulSubmit,
  userRoles,
  formData,
  navigationProps,
  sectionIndex,
  editingStatus,
}) => {

  // Props for the SectionNav in FormSection. these come from the parent but we mutate them to be relivent to the section
  const filteredNavigationProps = {
    ...navigationProps,
    submitForm: null,
  };

  const formattedSectionTitle = prefixStringWithIndexPlusOne(sectionTitle, sectionIndex);

  return (
    <FormSection
      sectionTitle={formattedSectionTitle}
      sectionId={sectionId}
      getCurrentFields={getCurrentFields}
      userRoles={userRoles}
      formData={formData}
      navigationProps={filteredNavigationProps}
      handleSuccessfulSubmit={handleSuccessfulSubmit}
      editingStatus={editingStatus}
    />
  );
});

ApproversSection.propTypes = {
  handleSuccessfulSubmit: PropTypes.func,
  userRoles: userRolesPropShape,
  formData: formDataShape,
  navigationProps: navigationPropsShape,
  sectionIndex: PropTypes.number,
  editingStatus: PropTypes.string,
};

export {
  ApproversSection,
  getCurrentFields,
  APPROVERS_SECTION,
};
